// React imports.
import React, { Component } from "react";

// App imports.


const StartPage = ({ state }) => (
    <div >
        <strong>PURPOSE OF THIS TOOL:</strong><br/>
        This tool is designed to help you assess the reliability of your electric baseload 
        expenditures data collected in Section V of the LIHEAP Performance Measures Form. 
        To begin, click <strong>Start New Assessment</strong> below.
        <br/><br/>
                        
        <strong>TOOL LAYOUT:</strong><br/>

        The <strong>Data Reliability Assessment Tool for Electric Baseload Expenditures</strong> consists 
        of the Overall Reliability Assessment and four in-depth assessments 
        (one for each step of the data reliability framework). This web
        application is designed to guide you through each assessment,
        helping you identify common data reliability issues and their potential causes. 
        <br/><br/>
        The first step in the process is to complete the Overall Reliability Assessment,
        which is designed to conduct a preliminary screening of your data and alert you
        to where your data look reliable and where you might want to dig deeper into
        potential issues using one of the other assessments.
        <br/><br/>
        After completing the Overall Assessment, the tool will direct you to focus 
        your attention on the in-depth assessments where data reliability issues 
        are most likely to be present. When potential data issues are identified, 
        the tool will prompt you to address plans to remedy those issues in the 
        &nbsp;<strong>Data Reliability Action Plan</strong>. When you have finished working through the
        tool, you will be able to print your results along with an aggregated 
        Action Plan.
        <br/><br/>
        Your progress will be saved as you work through each assessment. After 
        completing the assessments, you can view or print a summary of your
        results and your aggregated Data Reliability Action Plan. 
        To begin an assessment, click the Start New Assessment button.
        To view or edit a previous assessment, select it from the list below. 
        <br/><br/>

        {state.UserInfo.loggedIn === true
            &&
            <React.Fragment>
                <strong>START A NEW ASSESSMENT:</strong>
                <br/>
                <button className="dataButton" onClick={() => state.startPageAddAssessment()}
                    >Start New Assessment</button>
                  <br/><br/><br/>
                  <strong>VIEW/PRINT PREVIOUS ASSESSMENT RESULTS:</strong><br/>
                  {state.savedAssessments.length > 0 &&
                      <table >
                          <thead>
                              <tr>
                                  <th>Date Created</th>
                                  <th>Created by</th>
                                  <th>Fiscal Year</th>
                                  <th>Grant Recipient</th>
                                  <th>Assessment</th>
                                  <th>Action</th>
                              </tr>
                          </thead>
                          <tbody >
                          {state.savedAssessments.map(value => {
                              return (
                                  <tr key={value.assessmentId}>
                                    <td >{value.dateCreated}</td>
                                    <td >{value.userName}</td>
                                    <td >{value.fiscalYear}</td>
                                    <td >{value.granteeName}</td>
                                    <td >
                                          {value.assessmentType != "5"
                                            && <span>{value.assessmentType}</span>}
                                          {value.assessmentType == "5"
                                            && <span>Overall</span>}
                                    </td>
                                    <td>
                                          <a href="#" onClick={() => state.assessmentLoadActionPlan(value.assessmentId, value.assessmentType)}>View Action Plan</a>
                                          <br/>
                                          <a href="#" onClick={() => state.assessmentLoadSavedAssessment(value.assessmentId, value.assessmentType)}>Edit</a>
                                          <br/>
                                          <a href="#" onClick={() => state.deleteSavedAssessment(value.assessmentId, value.assessmentId2)}>Delete</a>
                                      </td>
                          
                                </tr>
                              );
                          })}
                
                          </tbody>
                      </table>
                  }
                  {state.savedAssessments.length === 0 &&
                      <span>No saved assessments</span>
                  }
            </React.Fragment>
        }
        {state.UserInfo.loggedIn !== true
            &&
            <React.Fragment>
                <strong>NOTE:</strong>&nbsp;
                In order to use this tool you must be signed into a LIHEAP Performance
                Management Site account.  <a href="/user#login">Click here to log in.</a>
            </React.Fragment>
        }
    </div>
);

export default StartPage;
